/**
 * The client-consumed subset of the closed binding-key registry. The WIRE
 * source of truth is the Go registry in
 * apps/api/internal/compliance/formtemplate/bindings.go (30 keys, pinned by
 * exact set in the Go suite); these constants carry ONLY the keys the clients
 * resolve or enforce, so a key rename fails compilation on every client call
 * site instead of silently un-binding a prefill or a spine check. The full
 * 30-key set is deliberately NOT duplicated here — the readings.* keys are
 * server-extracted, never client-resolved.
 */

/** gauge.* — the selected test kit's identity + latest calibration. */
export const GAUGE_BINDING_KEYS = {
  serialNumber: "gauge.serial_number",
  calibratedAt: "gauge.calibrated_at",
  calibrationExpiresAt: "gauge.calibration_expires_at",
} as const;

/** tester.* — the performer's newest live field-credential snapshot. */
export const TESTER_BINDING_KEYS = {
  certifyingBody: "tester.certifying_body",
  certNumber: "tester.cert_number",
  certExpiresAt: "tester.cert_expires_at",
} as const;

/**
 * The submission's regulatory spine: the outcome- and performed_at-projecting
 * bindings the server requires regardless of validation.required
 * (Derived.Outcome / Derived.PerformedAt must be total for the receive path
 * — an absent spine answer 422s required_enabled_missing). Mirrors
 * formtemplate/bindings.go's SpineBindingKeys — the FIVE-key union of
 * OutcomeBindingKeys (test.passed, inspection.outcome, incident.resolved) and
 * PerformedAtBindingKeys (test.performed_at, inspection.performed_at), pinned
 * across the twins through golden/vocabularies.json — so an offline finalize
 * can never pass a document the server is guaranteed to reject.
 */
export const SPINE_BINDING_KEYS = [
  "test.passed",
  "inspection.outcome",
  "incident.resolved",
  "test.performed_at",
  "inspection.performed_at",
] as const;
